import Vue from 'vue';
import { eventManager } from '@breakmedia/prime-vue-event-manager';
import module from '../store/coupon';
import CouponPageModal from '../CouponPageModal';

let failedCouponsPeriod = '24h';

const coupon = {
    applyDiscount(coupon) {
        if (coupon) {
            const couponProducts = coupon.products;
            let basketAmount = 0;
            let rrpBasketAmount = 0;

            if (coupon.redeemAssignedProductsOnly && couponProducts) {
                Object.values(Vue.$basket.getBasketItems()).forEach(item => {
                    if (couponProducts.includes(item.catalog_item_id)) {
                        basketAmount += item.price * item.quantity;
                        rrpBasketAmount += item.rrp_price * item.quantity;
                    }
                });
            } else {
                Object.values(Vue.$basket.getBasketItems()).forEach(item => {
                    basketAmount += item.price * item.quantity;
                    rrpBasketAmount += item.rrp_price * item.quantity;
                });
            }

            if (coupon.includeShippingCost) {
                basketAmount += Vue.$basket.getShippingTotal();
                rrpBasketAmount += Vue.$basket.getShippingTotal();
            }

            if (coupon.isAbsolute) {
                let couponAmount =  parseFloat(coupon.amount);
                if (coupon.subtractFromRrp) {
                    console.log(rrpBasketAmount, basketAmount);
                    couponAmount = Math.max((basketAmount - (rrpBasketAmount - couponAmount)), 0);
                    console.log(couponAmount);
                }
                Vue.$basket.addDiscount({
                    key: `coupon-${coupon.code}`,
                    value: couponProducts && couponProducts.length ?
                        Math.min(couponAmount, basketAmount) : couponAmount,
                });
            } else {
                let couponAmount = Math.round((basketAmount * coupon.amount + Number.EPSILON) * 100) / 100;

                if (coupon.subtractFromRrp) {
                    couponAmount = Math.round((rrpBasketAmount * coupon.amount + Number.EPSILON) * 100) / 100;
                    console.log(rrpBasketAmount, basketAmount);
                    couponAmount = Math.max((basketAmount - (rrpBasketAmount - couponAmount)), 0);
                    console.log(couponAmount);
                }
                Vue.$basket.addDiscount({
                    key: `coupon-${coupon.code}`,
                    value: couponAmount,
                });
            }
        }
    },
    getFailedCoupons() {
        const failedCouponsCookie = Vue.$cookies.get('failedCoupons');
        let failedCoupons = [];

        try {
            failedCoupons = JSON.parse(failedCouponsCookie);
        } catch {
        }

        return failedCoupons || [];
    },
    addFailedCoupon(coupon) {
        const failedCoupons = this.getFailedCoupons();

        if (!failedCoupons.includes(coupon)) {
            Vue.$cookies.set('failedCoupons', JSON.stringify([
                ...failedCoupons,
                coupon,
            ]), failedCouponsPeriod);
        }
    },
    removeFailedCoupon(coupon) {
        const failedCoupons = this.getFailedCoupons();

        if (failedCoupons.includes(coupon)) {
            failedCoupons.splice(failedCoupons.indexOf(coupon), 1);
            Vue.$cookies.set('failedCoupons', JSON.stringify(failedCoupons));
        }
    },
};

export default {
    install: function (Vue, options) {
        if (!Vue.$store.state.Coupon) {
            Vue.$store.registerModule('Coupon', module);
        }

        Vue.prototype.$coupon = coupon;
        Vue.$coupon = coupon;

        Vue.$router.onReady(() => {
            if (Vue.$router.currentRoute.query.cp) {
                Vue.$store.commit('setDynamicComponent', CouponPageModal);
                Vue.$store.commit('Coupon/setDisplayCouponModal', true);
            }
        });

        eventManager.$on('purchase', () => {
            Vue.$store.commit('Coupon/setPaidCouponCode', null);
        });

        if (options.failedCouponsPeriod) {
            failedCouponsPeriod = options.failedCouponsPeriod;
        }
    },
};
